import { render, staticRenderFns } from "./DialogId15.vue?vue&type=template&id=56f86ea3&scoped=true&"
import script from "./DialogId15.vue?vue&type=script&lang=js&"
export * from "./DialogId15.vue?vue&type=script&lang=js&"
import style0 from "./DialogId15.vue?vue&type=style&index=0&id=56f86ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56f86ea3",
  null
  
)

export default component.exports